export default __webpack_public_path__ + "static/media/whatsapp.0efcbba9.svg";